import { Button, CircularProgress, Grid, TextField } from "@material-ui/core";
import { ServiceUnavailableSlotInput } from "../../../graphql/models/ServiceUnavailableSlot";
import { ReactNode, useEffect, useState } from "react";
import { DateTime } from "luxon";
import { DateTimePicker, useStaticState } from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { GqlRecordPicker } from "../gql_record_picker";
import { MUTATIONS, QUERIES } from "../../../graphql";
import { Service } from "../../../graphql/models";
import { useSnackbarMutation } from "../../../hooks";

export interface UnavailableSlotsProps {
  onAdd: (value: ServiceUnavailableSlotInput) => void;
}

export function UnavailableSlot(props: UnavailableSlotsProps) {
  const { onAdd } = props;
  const next = DateTime.now()
    .setZone("Europe/Rome")
    .plus({ hour: 1 })
    .startOf("hour");
  const end = next.plus({ hour: 1 });
  const [serviceId, setServiceId] = useState("");
  const [blockedFrom, setBlockedFrom] = useState(next.toMillis());
  const [blockedTo, setBlockedTo] = useState(end.toMillis());
  const [blockedUnits, setBlockedUnits] = useState(1);
  const [notes, setNotes] = useState("");

  const [invokeCreateUnavailableSlot, { loading, data: unavailableSlotData }] =
    useSnackbarMutation(MUTATIONS.CREATE_UNAVAILABLE_SLOT);

  const dateHandler = (date: MaterialUiPickersDate) => {
    console.info(`date is `, date);
    if (!date) return 0;
    return date.valueOf();
  };

  const numberHandler = (value: string) => parseInt(value);

  const saveHandler = () => {
    if (!serviceId) {
      alert("Specificare il servizio");
      return;
    }
    let _from = DateTime.fromJSDate(new Date(blockedFrom));
    if (!_from.isValid) {
      alert(`La data di inizio non è valida: ${_from.invalidReason}`);
      return;
    }
    let _to = DateTime.fromJSDate(new Date(blockedTo));
    if (!_from.isValid) {
      alert(`La data di fine non è valida: ${_from.invalidReason}`);
      return;
    }
    if (isNaN(blockedUnits)) {
      alert(`Inserire un valore corretto nelle unità`);
      return;
    }
    if (_from > _to) {
      alert(`Inserire le date in ordine corretto`);
      return;
    }
    _from = _from.startOf("minute");
    _to = _to.startOf("minute");
    const blockedFromIso = _from.toISO();
    const blockedToIso = _to.toISO();
    if (!blockedFromIso || !blockedToIso) {
      alert(`Inserire date valide`);
      return;
    }
    const row: ServiceUnavailableSlotInput = {
      blockedFrom: blockedFromIso,
      blockedTo: blockedToIso,
      blockedUnits,
      notes,
      serviceId,
    };

    invokeCreateUnavailableSlot({
      variables: {
        data: row,
      },
    });
  };

  useEffect(() => {
    if (!!unavailableSlotData && onAdd) onAdd(unavailableSlotData);
  }, [unavailableSlotData, onAdd]);

  return (
    <>
      <Grid container spacing={1}>
        <Grid item lg={4}>
          <GqlRecordPicker
            multiple={false}
            query={QUERIES.BACKOFFICE_SERVICES}
            queryResultDataField="backofficeServices"
            placeHolder={"Servizio"}
            value={undefined}
            onValueChange={function (value: Service): void {
              if (!!value) setServiceId(value.id);
            }}
            getOptionLabel={function (value: Service): string {
              return value?.name ?? "-seleziona-";
            }}
            renderOption={function (value: Service): ReactNode {
              return <span>{value.name}</span>;
            }}
          ></GqlRecordPicker>
        </Grid>
        <Grid item lg={2}>
          <DateTimePicker
            style={{ width: "100%" }}
            format="dd/MM/yyyy HH:mm"
            placeholder="Inizio blocco"
            value={blockedFrom}
            inputVariant="outlined"
            onChange={(date) => setBlockedFrom(dateHandler(date))}
          ></DateTimePicker>
        </Grid>
        <Grid item lg={2}>
          <DateTimePicker
            style={{ width: "100%" }}
            format="dd/MM/yyyy HH:mm"
            placeholder="Inizio blocco"
            value={blockedTo}
            inputVariant="outlined"
            onChange={(date) => setBlockedTo(dateHandler(date))}
          ></DateTimePicker>
        </Grid>
        <Grid item lg={2}>
          <TextField
            variant="outlined"
            style={{ width: "100%" }}
            placeholder="Nr. di unità"
            value={blockedUnits}
            onChange={(e) => setBlockedUnits(numberHandler(e.target.value))}
          />
        </Grid>
        <Grid item lg={10}>
          <TextField
            variant="outlined"
            style={{ width: "100%" }}
            placeholder="Motivazione"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          ></TextField>
        </Grid>
        <Grid item lg={2}>
          {loading ? (
            <CircularProgress></CircularProgress>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={saveHandler}
              fullWidth={true}
              style={{ marginTop: "9px", height: "40px" }}
            >
              salva
            </Button>
          )}
        </Grid>
      </Grid>
    </>
  );
}
